function getYahooSymbol(symbol, exchange) {
    return exchange ? exchange.toLowerCase() === "tsx" ? symbol + ".to"
    : (exchange.toLowerCase() === "cse" ? symbol + ".cn"
       : (exchange.toLowerCase() === "tsxv" ? symbol + ".v"
          : (exchange.toLowerCase() === "neo" ? symbol + ".ne" : symbol))) : null;
 }

 export default getYahooSymbol;